export interface AiServiceModelPreset {
  label: string;
  value: string;
  inputCost?: number;
  outputCost?: number;
  benchmarks?: {
    mmlu: number;
    humaneval: number;
    gpqa?: number;
    arena_elo: number;
  };
}

export const aiServiceModelPresets: AiServiceModelPreset[] = [
  { 
    label: "GPT-4o", 
    value: "GPT-4o", 
    inputCost: 5, 
    outputCost: 15,
    benchmarks: { mmlu: 88.7, humaneval: 90.2, arena_elo: 1287 }
  },
  { 
    label: "Claude 3.5 Sonnet", 
    value: "Claude 3.5 Sonnet", 
    inputCost: 3, 
    outputCost: 15,
    benchmarks: { mmlu: 88.3, humaneval: 92.0, arena_elo: 1270 }
  },
  { 
    label: "GPT-4 Turbo", 
    value: "GPT-4 Turbo", 
    inputCost: 10, 
    outputCost: 30,
    benchmarks: { mmlu: 86.5, humaneval: 87.6, arena_elo: 1255 }
  },
  { 
    label: "Gemini 1.5 Pro", 
    value: "Gemini 1.5 Pro", 
    inputCost: 2.5, 
    outputCost: 7.5,
    benchmarks: { mmlu: 85.9, humaneval: 84.1, arena_elo: 1250 }
  },
  {
    label: "Custom",
    value: "Custom",
    inputCost: undefined,
    outputCost: undefined
  }
];

export const getAiServiceModelPreset = (value: string) =>
  aiServiceModelPresets.find(preset => preset.value === value);
